import { Container, Grid } from '@mui/material';
import React, { useState, useEffect } from 'react';
import Slider from "react-slick";
import {Link} from "react-router-dom";
import { jwtDecode } from 'jwt-decode';

export default function Homebanner() {
  const [isLoggedIn, setIsLoggedIn] = useState(false); 

  useEffect(() => {
    const token = localStorage.getItem('authToken');
    if (token) {
        try {
            jwtDecode(token); // Decode the token to verify it's valid
            setIsLoggedIn(true);
        } catch (error) {
            console.error('Invalid token:', error);
            setIsLoggedIn(false);
        }
    } else {
        setIsLoggedIn(false);
    }

}, []);

    var settings = {
    dots: false,
    nav:false,
    infinite: true,
    speed: 1000,
    slidesToShow: 1,
    slidesToScroll: 1,
  };
  return (
    <>
    <section className='homeslider relative'>
      {/* 
      <Slider {...settings}>
        
        
      </Slider> */}
      <img src="assets/images/left-leaf.png" className="absolute left-0 w-48 top-[120px] animationupdown md:block hidden z-[1]"/>
      <img src="assets/images/right-leaf.png" className="absolute right-0 w-56 bottom-[30px] animationupdown md:block hidden z-[1]"/>
      <div className='relative'>
          <img src='/assets/images/slide-01.jpg' className='w-full' alt=''/>
          <div className='absolute md:top-[35%] top-0 w-full md:h-auto h-full left-0 z-[1] md:pt-0 pt-4'>
            <Container className='h-full'>
              <Grid container spacing={2} className='h-full'>
                <Grid item xl={5} lg={6} md={12} xs={12} className='h-full'>
                  <h2 className='headningfont lg:text-6xl text-2xl lg:mb-6 mb-1 font-bold tracking-wide'>Sell Jewelry & Join The Market</h2>
                  <h3 className='lg:text-xl text-xs capitalize text-[#B3902D] tracking-wide lg:mb-10 mb-3 italic'>Providing with you the most convenient shopping</h3>
                  {isLoggedIn ? (
                    <Link to="/dashboard" className="inline-block md:py-4 py-2 px-3 md:px-6 bg-black text-white uppercase tracking-widest text-xs hover:bg-[#B3902D] transition-all z-30 mt-8 md:relative absolute bottom-4">Register Now</Link>
                    ) : (
                    <Link to="/register" className="inline-block md:py-4 py-2 px-3 md:px-6 bg-black text-white uppercase tracking-widest text-xs hover:bg-[#B3902D] transition-all z-30 mt-8 md:relative absolute bottom-4">Register Now</Link>
                    )}
                  
                  
                </Grid>
              </Grid>
            </Container>
          </div>
        </div>
    </section>
    </>
  )
}
